import { useFormContext } from '@astro/forms'
import { TextInput, getErrorMessage } from '../fields'
import SignaturePad from '../SignaturePad'
import { DECLARATIONS } from '../registerSteps'

export default function StepAgreement() {
  const { register, formState: { errors } } = useFormContext()

  return (
    <div className="step-panel space-y-4">
      <div className="space-y-3">
        {DECLARATIONS.map((text, i) => {
          const error = getErrorMessage(errors, `declarations.${i}`)
          return (
            <div key={text}>
              <label className="flex items-start gap-3 select-none cursor-pointer p-3 rounded-xl border border-stone-100 hover:bg-stone-50 transition-colors">
                <input
                  type="checkbox"
                  className="ar-check mt-0.5"
                  {...register(`declarations.${i}`, { required: 'Please accept all declarations to continue.' })}
                />
                <span className="text-[12.5px] text-stone-600 leading-relaxed">{text}</span>
              </label>
              {error && <p className="ar-error">{error}</p>}
            </div>
          )
        })}
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 pt-2">
        <TextInput
          name="applicant_name"
          label="Applicant Name"
          placeholder="Full legal name"
          rules={{ required: 'Applicant name is required.' }}
        />
        <TextInput name="declaration_date" type="date" label="Date" readOnly />
      </div>

      <SignaturePad name="signature" />
    </div>
  )
}
